import React, {Fragment, useMemo} from 'react';
import {connect} from 'react-redux';
import PortalItem from './subComponents/PortalItem/PortalItem';
import {getPortalsArr} from '../../../utils/functions';
import PortalErrorDisplay from './subComponents/PortalErrorDisplay/PortalErrorDisplay';

const PortalsPanel = ({portals, contentData}) => {
  const filteredPortals = useMemo(() => getPortalsArr(portals, contentData), [portals, contentData]);
  const isPortalsArrValid = filteredPortals?.length > 0;
  const {portalsSectionTitle} = contentData || {};

  return (
    <div className='business-dashboard-portals-panel-container'>
      <div className='portals-panel-title'>{portalsSectionTitle?.value || 'הפורטלים שלך'}</div>
      {isPortalsArrValid ? (
        <div className='portals-panel'>
          {filteredPortals.map((portal, index) => (
            <Fragment key={index}>
              {index > 0 && <div className='vertical-divider' />}
              <PortalItem portal={portal} />
            </Fragment>
          ))}
        </div>
      ) : (
        <PortalErrorDisplay contentData={contentData} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    canRenderPortals: state.portalsBlock.canRenderPortals,
  };
};

const mapDispatchToProps = {};
export default connect()(PortalsPanel);
